module.exports = __webpack_public_path__ + "static/media/hiking.b39e1f3b.jpg";